import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    content: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
    },
    questionnaireSelect: {
      minWidth: '320px',
    },
    emptyState: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      minHeight: 0,
    },
    emptyStateText: {
      fontSize: '16px',
      color: colors.color22,
    },
    questionsSection: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      gap: '12px',
    },
    questionsScrollableContent: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      gap: '12px',
    },
    questionsHeader: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    questionsTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    tabsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: '24px',
    },
    tab: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1,
      padding: '10px 14px',
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color10,
      backgroundColor: colors.color5,
      border: `1px solid ${colors.color32}`,
      borderRadius: '2px',
      cursor: 'pointer',
    },
    tabActive: {
      color: colors.color4,
      backgroundColor: `${colors.color4}12`,
      borderColor: colors.color4,
    },
    tabSubtext: {
      fontSize: '14px',
      fontWeight: '400',
    },
    selectedBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      minWidth: '20px',
      height: '20px',
      padding: '0 6px',
      borderRadius: '10px',
      fontSize: '12px',
      fontWeight: '600',
      backgroundColor: colors.color10,
      color: colors.color5,
      marginLeft: '6px',
    },
    questionsToolbar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      my: '4px',
    }, 
    questionsSubtitle: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '14px',
      fontWeight: '600',
      color: colors.color13,
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '16px',
      paddingRight: '16px',
    },
    actionLink: {
      fontSize: '14px',
      fontWeight: '500',
      color: colors.color4,
      cursor: 'pointer',
    },
    actionLinkDanger: {
      color: colors.color19,
    },
    searchField: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      paddingTop: '14px',
      backgroundColor: colors.color5,
      '& .MuiOutlinedInput-root': {
        height: '40px',
        paddingLeft: '10px',
      },
    },
    searchIcon: {
      display: 'flex',
      alignItems: 'center',
      color: colors.color10,
      marginRight: '8px',
    },
    questionsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      border: `1px solid ${colors.color39}`,
      borderRadius: '2px',
      padding: '0px 16px 16px 16px',
    },
    questionsEmptyState: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      minHeight: 0,
      padding: '40px 16px',
    },
    questionsEmptyStateText: {
      fontSize: '16px',
      color: colors.color22,
      textAlign: 'center',
    },
    questionRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 2px',
      border: `1px solid ${colors.color39}`,
      borderRadius: '4px',
      cursor: 'pointer',
      backgroundColor: colors.color5,
      transition: 'all 0.2s ease',
    },
    questionCheckbox: {
      padding: '2px',
      '& .MuiBox-root': { width: '22px', height: '22px' }
    },
    questionContent: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minWidth: 0,
    },
    questionTitle: {
      fontSize: '14px',
      fontWeight: '500',
      color: colors.color13,
    },
    questionSection: {
      fontSize: '12px',
      color: colors.color10,
    },
    loadingText: {
      margin: 'auto',
      fontSize: '14px',
      color: colors.color10,
    },
    errorMessage: {
      fontSize: '14px',
      color: colors.color19,
    },
  }
}
